import React from "react";

export const Typography = ({text}) => {
    return <React.Fragment>{text}</React.Fragment>;
};
